import { render } from "./EndpointParameter.vue?vue&type=template&id=63622f8d"
import script from "./EndpointParameter.vue?vue&type=script&lang=js"
export * from "./EndpointParameter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__